import type React from 'react'
import type { ReactNode } from 'react'

import { useBreadcrumb } from 'commons/customHooks/useBreadcrumbs'
import { NotificationsProvider } from 'commons/customHooks/useNotifications'
import { LoadingModal, MenuSidebar, MenuTopbar } from 'components'

import { menuObj } from '../MenuSidebar/constants'
import {
  GridContainerStyled,
  GridContentStyled,
  Main,
  PaperStyled,
  WrapContainerStyled,
} from './styles'

export interface PageProps {
  children: ReactNode
  hasHeader?: boolean
  renderContent?: boolean
  fullwidth?: boolean
  renderHeaderComponent?: ReactNode
  loading?: boolean
}

export const Page: React.FC<PageProps> = ({
  children,
  hasHeader = true,
  renderContent = true,
  fullwidth = false,
  loading = false,
  renderHeaderComponent = <></>,
}) => {
  useBreadcrumb()
  return (
    <>
      {loading && <LoadingModal />}
      <NotificationsProvider>
        <PaperStyled square>
          {hasHeader && (
            <>
              <MenuTopbar />
              <MenuSidebar footer={[]} menu={menuObj} />
            </>
          )}
          <Main>
            <WrapContainerStyled
              disableGutters
              fullwidth={fullwidth ? 'true' : 'false'}
              header={hasHeader ? 1 : 0}
              maxWidth={'lg'}
            >
              <GridContainerStyled container direction="column" justifyContent="space-between">
                {renderHeaderComponent}
                <GridContentStyled fullwidth={fullwidth ? 'true' : 'false'} item xs={12}>
                  {renderContent && children}
                </GridContentStyled>
              </GridContainerStyled>
            </WrapContainerStyled>
          </Main>
        </PaperStyled>
      </NotificationsProvider>
    </>
  )
}
